/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import { or } from '@ember/object/computed';
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import SubjectStepModel from 'cio/models/subject-step';
import { unixNowSeconds } from 'cio/utils/time';

interface JourneyStepArgs {
  step: SubjectStepModel;
  campaign?: CampaignModel;
  subjectStateIsLeaving: boolean;
}

// Step icon chosen based on the first of these attributes to be true
const ICON_ATTRS = ['isMatch', 'isExit', 'isSkipped'];

const STEP_ICONS = {
  isMatch: 'campaigns',
  isExit: 'exit',
  isSkipped: 'wait',
  default: 'check-circle',
};

class JourneyStep extends Component<JourneyStepArgs> {
  @or('args.step.isMatch', 'args.step.isExit', 'args.step.future') muted!: boolean;
  @or('args.step.isMatch', 'args.step.isExit', 'args.step.isGracePeriod') borderless!: boolean;

  @computed(`args.step.{${ICON_ATTRS.join(',')}}`)
  get journeyIcon() {
    let attr = ICON_ATTRS.find((a) => this.args.step.get(a as any)) ?? 'default';

    return STEP_ICONS[attr as keyof typeof STEP_ICONS];
  }

  get isDuration() {
    return this.args.step.future && this.args.step.entered < unixNowSeconds();
  }

  get objectNoun() {
    if (this.args.campaign?.isDataCampaign) {
      return 'object';
    }

    return 'person';
  }

  get hideExplanation() {
    return this.args.step.isExit && this.args.subjectStateIsLeaving;
  }
}

export default JourneyStep;
